export { PdpCrawlableContent } from './PdpCrawlableContent';
